import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import compileExpression from 'filtrex'
import styled from 'styled-components'

import Text from '../Text'
import Loading from '../Loading'
import Table from '../Table'

export const GET_MANUFACTURERS = gql`
  {
    manufacturers {
      id
      name
      models {
        id
      }
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

let operand = '==',
    value   = ''

const columns = [
  {Header: 'Name', accessor: 'name'},
  {
    id: 'id', Header: 'Model Count', accessor: m => m.models.length,
    filterMethod: (filter, row) => {
      try {
        const expression = `${filter.id} ${operand} ${filter.value}`
        const compare = compileExpression(expression)
        return compare(row) === 1
      } catch (e) {
        return false
      }
    },
    Filter: ({filter, onChange}) =>
      <Wrapper>
        <select
          onChange={event => {
            operand = event.target.value
            onChange(value)
          }}
          style={{width: '50%', height: 28}}>
          <option value='=='>Equals</option>
          <option value='>'>Greater Than</option>
          <option value='<'>Less Than</option>
        </select>
        <input
          onChange={event => {
            value = event.target.value
            onChange(value)
          }}
          style={{width: '50%'}}
          value={filter ? filter.value : ''}
        />
      </Wrapper>
  }
]

const List = ({onRowClick, filterable}) =>
  <Query query={GET_MANUFACTURERS} fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (error) return <Text error>{error.message}</Text>

      return (
        <React.Fragment>
          {loading && <Loading />}
          <Table
            filterable={filterable}
            noDataText={!loading && 'No manufacturers found!'}
            loading={loading}
            data={data.manufacturers}
            columns={columns}
            onRowClick={onRowClick}
          />
        </React.Fragment>
      )
    }}
  </Query>

export default List


// WEBPACK FOOTER //
// ./src/components/Manufacturers/List.js